<template>
  <v-row>
    <v-col cols="6">
      <v-text-field class="input-text-size pt-0 pb-0"
       readonly tabindex="-1" v-model.number="editedItem.taxYear" label="Tax Year" />
      <v-row>
        <v-col cols="6">
          <v-text-field class="input-text-size pt-0 pb-0 mt-n2"
       readonly tabindex="-1" v-model.number="editedItem.taxId" label="Tax ID" />
        </v-col>
        <v-col cols="6">
          <v-text-field class="input-text-size pt-0 pb-0 mt-n2"
          readonly tabindex="-1" v-model="editedItem.propertyOrParcelId" label="Parcel ID" />
        </v-col>
      </v-row>
      <v-text-field class="input-text-size pt-0 pb-0 mt-n2"
       readonly tabindex="-1" v-model="editedItem.taxDistrict"
        label="Tax District" />
      <ClarionDateControl v-model="editedItem.dateOverpaid"
       :isToggle="false" :isDisabled="true" label="Date Overpaid"
        class="input-text-size pt-0 pb-0 mt-n2" />
      <v-autocomplete :items="overPayList" v-model="editedItem.type"
       class="input-text-size" label="Overpayment Type"
        item-text="name" item-value="value" readonly tabindex="-1" />
      <v-autocomplete :items="userList" v-model="editedItem.assignedTo"
       class="input-text-size" label="Assigned To"
        item-text="fullname" item-value="username"
        :readonly="!isTaxAdmin" :tabindex="!isTaxAdmin ? -1 : 0" />
      <v-checkbox class="input-text-size" v-model="editedItem.resolved" label="Resolved" />
    </v-col>
    <v-col cols="6">
      <v-text-field class="input-text-size pt-0 pb-0" readonly tabindex="-1"
        v-model.number="editedItem.taxAmt"
        label="Tax Amount Due" />
      <v-text-field class="input-text-size pt-0 pb-0 mt-n2"
       readonly tabindex="-1" v-model.number="editedItem.paidTax"
        label="Taxes Paid" />
      <v-text-field class="input-text-size pt-0 pb-0 mt-n2"
       readonly tabindex="-1" v-model.number="editedItem.overPaidAmt"
        label="Overpaid Amount" />

      <v-row>
        <v-col cols="4">
          <v-select
            label="Fiscal Year"
            class="input-text-size pa-0 mb-n2"
            v-model="fiscalYear"
            item-text="name"
            item-value="value"
            :items="fiscalYearSelectList"
          />
        </v-col>
        <v-col cols="4">
        <!-- auto complete for shared fund -->
          <v-autocomplete
            label="Shared Fund"
            class="input-text-size pa-0 mb-n2"
            v-model="editedItem.fund"
            item-text="fundDesc"
            item-value="_id"
            :items="funds"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="4">
          <!-- auto complete for warrant no -->
          <v-text-field class="input-text-size pa-0 mb-n2"
            v-model.number="editedItem.warrant"
            :label="inputLabel"
            @input="handleInput"
            />

        </v-col>
        <v-col cols="6">
          <ClarionDateControl
            class="input-text-size"
            v-model="editedItem.issueDate"
            :isToggle="false"
            :isDisabled="editedItem.warrant ? disabledIssueDate : false"
            label="Issue Date" />
        </v-col>
        <v-col cols="6">
          <ClarionDateControl
            class="input-text-size pa-0 mb-n2"
            :isToggle="false"
            :isDisabled="editedItem.warrant ? disabledPaidDate : false"
            v-model="editedItem.paidDate"
            label="Paid Date"
            />
        </v-col>
      </v-row>
      <v-textarea class="input-text-size pt-0 pb-0"
       v-model="editedItem.comments" outlined rows="4" label="Comments"
       v-textAreaUppercase=globalSettingItem.conEverythingToCaps />
    </v-col>
  </v-row>
</template>

<script>

import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import ClarionDateControl from '../../../../common/ClarionDateControl.vue';
import { overpaymentsNRefundsDropDownList } from '../../../TaxInquiry/TaxInquiryUtils/TableHeaders.utils';
import { toFiscalYear, toShortDate } from '../../../../../util/shared/tmc-global';
import GlobalToCaps from '../../../../../util/shared/GlobalToCaps.mixin.vue';

const fundCrudKey = 'sharedFund';

export default {
  name: 'OverpaymentsNRefundsDialog',
  mixins: [GlobalToCaps],
  components: {
    ClarionDateControl,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'OverpaymentsNRefundsList',
    },
    userList: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    overPayList: overpaymentsNRefundsDropDownList,
    timeout: null,
    fiscalYear: '',
    disabledPaidDate: false,
    disabledIssueDate: false,
  }),
  computed: {
    ...mapGetters('base/crud', [
      'item', 'items', 'isVisible',
    ]),
    ...mapGetters('auth/token', [
      'authUserRoles',
    ]),
    ...mapState({
      nextWarrantNumber: (state) => state.war.transaction.nextWarrantNumber,
      fiscalYearList: (state) => state.tax.taxCommon.fiscalYearList,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    ...mapGetters([
      'todaysDate',
    ]),
    isTaxAdmin() {
      return (this.authUserRoles || []).includes('TaxAdministration') || (this.authUserRoles || []).includes('TmcSupport');
    },
    inputLabel() {
      if (this.nextWarrantNumber === undefined) {
        return 'Warrant # (of refund warrant)';
      }
      return `Warrant# (last: ${this.nextWarrantNumber - 1})`;
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    funds() {
      const fundObjs = this.items(fundCrudKey) || [];
      const updatedFundObj = fundObjs.map((f) => ({
        ...f,
        fundDesc: f.fund === '0000' ? `${f.fund} - ${f.description || ''}` : `${f.fund} - ${f.description || ''}`,
      }));
      return [...updatedFundObj]; // { _id: null, fund: '', fundDesc: '' },
    },
    dialogVisible() {
      return this.isVisible(this.baseCrudKey);
    },
    fiscalYearSelectList() {
      return (this.fiscalYearList || []).filter((fy) => fy.value !== 0);
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
    ...mapActions('shared/fund', [
      'loadFunds',
    ]),
    ...mapActions('tax/taxInquires', [
      'checkWarrantNo',
    ]),
    ...mapActions('UserAdministration', [
      'loadUsers',
    ]),
    loadFundList(fy) {
      this.loadFunds({
        criteria: {
          fiscalYear: fy || 0,
          sortBy: [
            {
              column: 'fund',
              direction: 'asc',
            },
          ],
        },
        baseCrudKey: fundCrudKey,
      });
    },
    async handleInput() {
      clearTimeout(this.timeout);
      const { warrant, fund } = this.editedItem;
      this.timeout = setTimeout(async () => {
        if (/^\d+$/.test(warrant)) {
          const criteria = {
            warrant: parseInt(warrant, 10),
            fund: fund._id ? fund._id : fund,
            fiscalYear: parseInt(this.fiscalYear, 10),
          };
          const res = await this.checkWarrantNo({ criteria });

          if (res.status) {
            const warrantAmt = parseFloat(res.amount) || 0;
            const overpaidAmt = parseFloat(this.editedItem.overPaidAmt) || 0;
            if (warrantAmt !== overpaidAmt) {
              const proceed = window.confirm(
                `Warning: Warrant amount ($${warrantAmt}) does not match Overpaid Amount ($${overpaidAmt}). Do you want to continue?`,
              );
              if (!proceed) {
                this.editedItem.warrant = null;
                return;
              }
            }
            this.editedItem.issueDate = toShortDate(res.issueDate);
            this.editedItem.paidDate = toShortDate(res.paidCancelledDate);
            if (res.issueDate) {
              this.disabledIssueDate = true;
            }
            if (res.paidCancelledDate) {
              this.disabledPaidDate = true;
            }
          } else {
            alert('No Warrent available for this fund');
            this.editedItem.issueDate = null;
            this.editedItem.paidDate = null;
            this.disabledIssueDate = false;
            this.disabledPaidDate = false;
          }
        }
      }, 1000);
    },
    /**
     * Point the Fiscal Year select, the record, and the shared fund list at the same year.
     *
     * Called only from handleDialogOpen(), which the immediate dialogVisible watcher runs.
     * That covers creation as well as every reopen: CRUDDialog's v-dialog has no eager
     * prop, so this content is lazily mounted and the component is not created until the
     * dialog is already visible - the immediate handler seeds it right there. A created()
     * hook would only repeat that first seed, and with it the loadFunds call, so there
     * isn't one.
     *
     * It must do the write-back itself rather than leave it to the fiscalYear watcher.
     * Vue only fires that watcher when the value actually changes, so two records that
     * resolve to the same year - the normal case, since 63 of 65 counties have never set
     * the field and both fall back to today's - would leave the select showing the right
     * year while the record was never stamped, and saving would persist nothing
     * (TKT-000742).
     *
     * Keep the value NUMERIC - fiscalYearSelectList uses item-value="value" with numeric
     * years, so a stringified year matches no option and the select renders blank. Use ||
     * not ?? - 0 is this codebase's "(all years)" sentinel and is filtered out of the
     * picker, so a stray 0 must fall through to today's fiscal year.
     */
    seedFiscalYear() {
      const fy = this.editedItem.fiscalYear
        || toFiscalYear(new Date(this.todaysDate));
      this.fiscalYear = fy;
      this.$set(this.editedItem, 'fiscalYear', parseInt(fy, 10));
      this.loadFundList(fy);
    },
    handleDialogOpen() {
      this.seedFiscalYear();
      if (!this.editedItem.warrant) {
        this.disabledIssueDate = false;
        this.disabledPaidDate = false;
        this.editedItem.issueDate = this.editedItem.issueDate
          ? toShortDate(this.editedItem.issueDate) : null;
        this.editedItem.paidDate = this.editedItem.paidDate
          ? toShortDate(this.editedItem.paidDate) : null;
      } else {
        if (this.editedItem.issueDate) {
          this.disabledIssueDate = true;
        }

        if (this.editedItem.paidDate) {
          this.disabledPaidDate = true;
        }
      }
    },
  },
  watch: {
    dialogVisible: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.handleDialogOpen();
        }
      },
    },
    fiscalYear(newVal) {
      if (newVal) {
        this.$set(this.editedItem, 'fiscalYear', parseInt(newVal, 10));
        this.loadFundList(newVal);
      }
    },
  },
};
</script>
